import _ from 'lodash'
import { Map, Record } from 'immutable'

import { OPEN_DROPDOWN_MENU, CLOSE_DROPDOWN_MENU, TOGGLE_DROPDOWN_MENU } from './constants'

const DropDownMenuRecord = Record({
    open: false,
})

export default (state = Map(), action = {}) => {
    switch (action.type) {
        case OPEN_DROPDOWN_MENU: {
            const name = _.get(action, 'data.name', '')

            return state.set(name, new DropDownMenuRecord({ open: true }))
        }
        case CLOSE_DROPDOWN_MENU: {
            const name = _.get(action, 'data.name', '')

            return state.set(name, new DropDownMenuRecord({ open: false }))
        }
        case TOGGLE_DROPDOWN_MENU: {
            const name = _.get(action, 'data.name', '')
            const open = state.getIn([name, 'open']) || false

            return state.set(name, new DropDownMenuRecord({ open: !open }))
        }
        default:
            return state
    }
}
